import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";

import * as Model from "../model";

import type * as _Model from "../../../../model";

type Props = {
	viewData: _Model.Type.ViewData;
};

export const CsvDownloadPerReservationForReservationSearch = ({ viewData }: Props) => {
	/**
	 * 初期化
	 */
	const { onCsvDownload } = Model.UseCase.useInitialized({ viewData });

	/**
	 * ダウンロード押下処理
	 */
	const handleClickCsvDownload = useCallback(() => {
		onCsvDownload();
	}, [onCsvDownload]);

	return (
		<Button variant="outline" size="sm" type="button" onClick={handleClickCsvDownload}>
			CSVダウンロード（予約ごと）
		</Button>
	);
};
